import {
  FETCH_PROMO_LOADING,
  FETCH_PROMO_DONE,
  FETCH_PROMO_ERROR,
  FETCH_PROMO_DETAILS_LOADING,
  FETCH_PROMO_DETAILS_DONE,
  FETCH_PROMO_DETAILS_ERROR,
  POST_DATA_TEMP
} from './actions'

export default {
  [FETCH_PROMO_LOADING] (state) {
    state.isLoading = true
  },

  [FETCH_PROMO_DONE] (state, promo) {
    state.promo = promo
    state.isLoading = false
  },

  [FETCH_PROMO_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },
  [FETCH_PROMO_DETAILS_LOADING] (state) {
    state.isLoadingPromoDetails = true
    state.isErrorPromoDetails = false
  },

  [FETCH_PROMO_DETAILS_DONE] (state, items) {
    state.promoDetails = items
    state.isLoadingPromoDetails = false
    state.isErrorPromoDetails = false
  },

  [FETCH_PROMO_DETAILS_ERROR] (state, error) {
    state.isErrorPromoDetails = true
    state.isLoadingPromoDetails = false
    state.promoDetails = []
  },

  [POST_DATA_TEMP] (state, items) {
    state.dataTemp = items
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/promo/mutations.js